<div fxLayout="column" fxLayoutAlign="center center" fxFlexFill>

    <div fxLayout="column" fxLayoutAlign="center center" class="layout-padd text-center mat-title">

        <i class="fas fa-exclamation-triangle warn-ico" style="font-size: 100px;"></i>

        <div style="margin-top: 50px;" class=" boldest">{{'stripeErrors.error'|translate}} <span *ngIf="order_id">{{'numberCommand'|translate}}{{order_id}}</span></div>
       
       <div  class=" boldest" [innerHTML]="(recharge||credit?'refill_creditProcessed':'commandProcessed')|translate"></div>

        <div fxLayout="row" class=" full-w" fxLayoutGap="5px" style="font-size: 8px;" fxLayoutAlign="start center">
            <div *ngIf="error&& error.paimentStatus || error.error &&error.error.paimentStatus">
                {{(error.paimentStatus && error.paimentStatus=='succeeded'?'errorStatusSucceded':'errorStatusNotSucceded')|translate}}
            </div>
            <div *ngIf="error && error.orderCaptured || error.error &&error.error.orderCaptured ">
                {{(error.orderCaptured ||error.error.orderCaptured ?'errorOrderCaptured':'errorNotOrderCaptured')|translate}}
            </div>
        </div>
      
    </div>




    <!-- button -->

    <div class="positionBottomtouchcancel">

        <div class="layout-padd" fxLayoutGap="10px" fxLayout="row" fxFlexFill>
            <button mat-stroked-button class="full-w dark-ico" (click)="closeDial()" angulartics2On="click"
                angularticsAction="closeYetCapturedDial" angularticsCategory="order">
                <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
            </button>


        </div>

    </div>